import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0A0A14] text-[#F0EFF8]" style={{ fontFamily: 'Sora, sans-serif' }}>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A14]/80 backdrop-blur-xl border-b border-white/[0.06]">
        <div className="max-w-[1400px] mx-auto px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/601b8a805a2f0f27f21e1ce6d1f2a810/80ae8f6d2d425f94fe707693601f876c.png"
              alt="Intevo Labs"
              className="h-9 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="px-6 py-3 bg-[#7B3FE4] hover:bg-[#6B2FD4] text-white font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            style={{ borderRadius: '2px', fontSize: '14px' }}
          >
            Volver al inicio
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-8">
          {/* Page Title */}
          <div className="mb-16">
            <h1 className="text-5xl font-bold mb-6" style={{ lineHeight: '1.2' }}>
              Términos de Uso
            </h1>
            <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                1. Aceptación de los Términos
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Bienvenido a Intevo Labs. Al acceder y utilizar nuestro sitio web y servicios, aceptas estar sujeto a estos Términos de Uso, todas las leyes y regulaciones aplicables, y aceptas que eres responsable del cumplimiento de todas las leyes locales aplicables.
              </p>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Si no estás de acuerdo con alguno de estos términos, tienes prohibido usar o acceder a este sitio y nuestros servicios. Los materiales contenidos en este sitio web están protegidos por las leyes de derechos de autor y marcas comerciales aplicables.
              </p>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Estos términos constituyen un acuerdo legal vinculante entre tú (el "Cliente" o "Usuario") e Intevo Labs (la "Empresa", "nosotros" o "nuestro").
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                2. Descripción de los Servicios
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Intevo Labs proporciona servicios de automatización empresarial mediante inteligencia artificial, que incluyen pero no se limitan a:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>Desarrollo e implementación de agentes de IA para automatización de procesos</li>
                <li>Integración de sistemas y herramientas empresariales</li>
                <li>Optimización y auditoría de procesos de negocio</li>
                <li>Desarrollo de herramientas internas personalizadas</li>
                <li>Consultoría en transformación digital y automatización</li>
                <li>Soporte técnico continuo y mantenimiento de sistemas</li>
              </ul>
              <p className="text-[#8887A0] mt-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Los servicios específicos, alcance, entregables y plazos se definirán en acuerdos comerciales separados o propuestas de proyecto individuales.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                3. Uso del Sitio Web
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    3.1 Licencia de Uso
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Se te otorga una licencia limitada, no exclusiva, no transferible y revocable para acceder y utilizar nuestro sitio web únicamente para fines informativos y comerciales legítimos relacionados con nuestros servicios.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    3.2 Restricciones de Uso
                  </h3>
                  <p className="text-[#8887A0] mb-3" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    No puedes:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    <li>Modificar o copiar los materiales del sitio sin autorización</li>
                    <li>Usar los materiales para fines comerciales no autorizados</li>
                    <li>Intentar descompilar o realizar ingeniería inversa de cualquier software del sitio</li>
                    <li>Eliminar derechos de autor u otras notaciones de propiedad</li>
                    <li>Transferir los materiales a otra persona o "reflejar" los materiales en otro servidor</li>
                    <li>Utilizar el sitio de manera que pueda dañar, deshabilitar o perjudicar nuestros sistemas</li>
                    <li>Intentar obtener acceso no autorizado a cualquier parte del sitio</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                4. Propiedad Intelectual
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Todo el contenido incluido en este sitio web, como texto, gráficos, logotipos, iconos, imágenes, clips de audio, descargas digitales y compilaciones de datos, es propiedad de Intevo Labs o de sus proveedores de contenido y está protegido por las leyes internacionales de derechos de autor.
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    4.1 Marcas Comerciales
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    "Intevo Labs" y otros nombres, logotipos y marcas relacionadas son marcas comerciales de Intevo Labs. No puedes usar estas marcas sin nuestro consentimiento previo por escrito.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    4.2 Propiedad de Entregables
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Los derechos de propiedad sobre los entregables del proyecto (código, documentación, sistemas implementados) se definirán específicamente en los acuerdos comerciales individuales. Generalmente, el cliente recibe una licencia de uso sobre las soluciones implementadas, mientras que Intevo Labs retiene la propiedad de metodologías, frameworks y componentes reutilizables.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                5. Responsabilidades del Cliente
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Como cliente de nuestros servicios, te comprometes a:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>Proporcionar información precisa y completa sobre tus procesos y necesidades</li>
                <li>Facilitar el acceso necesario a sistemas, datos y personal para la implementación</li>
                <li>Designar un punto de contacto autorizado para la toma de decisiones del proyecto</li>
                <li>Revisar y aprobar entregables dentro de los plazos acordados</li>
                <li>Cumplir con los términos de pago establecidos en el acuerdo comercial</li>
                <li>Mantener la confidencialidad de credenciales y accesos proporcionados</li>
                <li>Usar las soluciones implementadas de acuerdo con las mejores prácticas recomendadas</li>
                <li>Notificar inmediatamente cualquier problema o incidente de seguridad</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                6. Limitación de Responsabilidad
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                En la máxima medida permitida por la ley aplicable:
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    6.1 Exclusión de Garantías
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Los materiales en el sitio web de Intevo Labs se proporcionan "tal cual". Intevo Labs no ofrece garantías, expresas o implícitas, y por la presente renuncia y niega todas las demás garantías, incluidas, entre otras, garantías implícitas o condiciones de comerciabilidad, idoneidad para un propósito particular o no infracción de propiedad intelectual u otra violación de derechos.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    6.2 Limitaciones de Daños
                  </h3>
                  <p className="text-[#8887A0] mb-3" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    En ningún caso Intevo Labs o sus proveedores serán responsables de daños (incluidos, entre otros, daños por pérdida de datos o ganancias, o debido a la interrupción del negocio) que surjan del uso o la imposibilidad de usar los materiales en el sitio web de Intevo Labs, incluso si Intevo Labs o un representante autorizado de Intevo Labs ha sido notificado oralmente o por escrito de la posibilidad de tales daños.
                  </p>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Nuestra responsabilidad total hacia ti por cualquier reclamo relacionado con nuestros servicios no excederá el monto pagado por ti a Intevo Labs durante los doce (12) meses anteriores al evento que dio lugar al reclamo.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    6.3 Servicios de Terceros
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Nuestros servicios pueden integrarse con plataformas y servicios de terceros. No somos responsables del rendimiento, disponibilidad o políticas de estos servicios de terceros. Tu uso de servicios de terceros está sujeto a sus propios términos y condiciones.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                7. Confidencialidad
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Ambas partes reconocen que durante el curso de nuestra relación comercial pueden tener acceso a información confidencial de la otra parte.
              </p>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    7.1 Definición
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    "Información Confidencial" incluye, pero no se limita a, información técnica, comercial, financiera, de clientes, procesos de negocio, código fuente, diseños, metodologías y cualquier otra información no pública compartida entre las partes.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    7.2 Obligaciones
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Cada parte se compromete a: (a) mantener la confidencialidad de la información, (b) no divulgarla a terceros sin consentimiento previo por escrito, (c) usarla únicamente para los fines del proyecto, y (d) protegerla con el mismo nivel de cuidado que protege su propia información confidencial.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                8. Términos de Pago
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Los términos de pago específicos se establecerán en propuestas y acuerdos comerciales individuales. Generalmente:
              </p>
              <ul className="list-disc list-inside space-y-2 text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                <li>Los pagos se realizarán según el calendario acordado en la propuesta del proyecto</li>
                <li>Las facturas vencen dentro de los 30 días posteriores a la fecha de emisión, salvo que se acuerde lo contrario</li>
                <li>Los pagos atrasados pueden estar sujetos a cargos por intereses</li>
                <li>Nos reservamos el derecho de suspender servicios en caso de falta de pago</li>
                <li>Los reembolsos, si corresponden, se manejarán según lo especificado en el acuerdo comercial</li>
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                9. Terminación
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    9.1 Terminación por Conveniencia
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Cualquiera de las partes puede terminar un proyecto en curso con un aviso por escrito de 30 días. El cliente será responsable del pago de todo el trabajo completado hasta la fecha de terminación, más cualquier costo no recuperable incurrido.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    9.2 Terminación por Causa
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Cualquiera de las partes puede terminar el acuerdo inmediatamente si la otra parte: (a) incumple materialmente estos términos y no corrige el incumplimiento dentro de los 15 días posteriores a la notificación por escrito, (b) se declara en quiebra o insolvencia, o (c) cesa sus operaciones comerciales.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    9.3 Efectos de la Terminación
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Tras la terminación: (a) cesarán todos los derechos de acceso y uso, (b) se pagarán todas las cantidades adeudadas, (c) cada parte devolverá o destruirá la información confidencial de la otra parte, y (d) sobrevivirán las disposiciones que por su naturaleza deban continuar (confidencialidad, propiedad intelectual, limitación de responsabilidad).
                  </p>
                </div>
              </div>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                10. Indemnización
              </h2>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Aceptas indemnizar, defender y eximir de responsabilidad a Intevo Labs, sus directores, empleados, agentes y afiliados de y contra todas las reclamaciones, daños, obligaciones, pérdidas, responsabilidades, costos o deudas, y gastos (incluidos, entre otros, los honorarios de abogados) que surjan de: (a) tu uso de nuestros servicios, (b) tu violación de estos términos, (c) tu violación de cualquier derecho de terceros, incluidos, entre otros, derechos de propiedad intelectual, o (d) cualquier contenido o datos que proporciones.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                11. Modificaciones de los Términos
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Intevo Labs puede revisar estos términos de uso en cualquier momento sin previo aviso. Al usar este sitio web, aceptas estar sujeto a la versión actual de estos Términos de Uso.
              </p>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Los cambios materiales a estos términos se notificarán mediante la publicación de los términos actualizados en nuestro sitio web con una nueva fecha de "Última actualización". Tu uso continuado de nuestros servicios después de dichos cambios constituye tu aceptación de los nuevos términos.
              </p>
            </section>

            {/* Section 12 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                12. Ley Aplicable y Jurisdicción
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Estos términos se regirán e interpretarán de acuerdo con las leyes aplicables, sin tener en cuenta sus disposiciones sobre conflictos de leyes.
              </p>
              <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Cualquier disputa que surja de o relacionada con estos términos o nuestros servicios se resolverá primero mediante negociación de buena fe. Si no se puede resolver mediante negociación, las partes acuerdan someterse a mediación antes de iniciar cualquier procedimiento legal.
              </p>
            </section>

            {/* Section 13 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                13. Disposiciones Generales
              </h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    13.1 Acuerdo Completo
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Estos términos, junto con cualquier acuerdo comercial específico, constituyen el acuerdo completo entre tú e Intevo Labs con respecto al uso de nuestros servicios.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    13.2 Divisibilidad
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    Si alguna disposición de estos términos se considera inválida o inaplicable, dicha disposición se eliminará y las disposiciones restantes seguirán siendo válidas y aplicables.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    13.3 Renuncia
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    El hecho de que no hagamos cumplir algún derecho o disposición de estos términos no constituirá una renuncia a ese derecho o disposición.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#F0EFF8' }}>
                    13.4 Cesión
                  </h3>
                  <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                    No puedes ceder o transferir estos términos o tus derechos bajo estos términos sin nuestro consentimiento previo por escrito. Podemos ceder estos términos sin restricciones.
                  </p>
                </div>
              </div>
            </section>

            {/* Section 14 */}
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#F0EFF8' }}>
                14. Contacto
              </h2>
              <p className="text-[#8887A0] mb-4" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                Si tienes preguntas sobre estos Términos de Uso, puedes contactarnos:
              </p>
              <div className="bg-white/[0.02] border border-white/[0.06] p-6" style={{ borderRadius: '2px' }}>
                <p className="text-[#F0EFF8] mb-2" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  <strong>Intevo Labs</strong>
                </p>
                <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  Correo electrónico: hola@intevolabs.com
                </p>
                <p className="text-[#8887A0]" style={{ fontSize: '16px', lineHeight: '1.75' }}>
                  Formulario de contacto: Disponible en nuestra página principal
                </p>
              </div>
            </section>
          </div>

          {/* Back to Home Link */}
          <div className="mt-16 pt-8 border-t border-white/[0.06]">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#7B3FE4] hover:text-[#9B6FE4] transition-colors duration-200 cursor-pointer"
              style={{ fontSize: '16px', fontWeight: '600' }}
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}